import { BoMCreate } from "./BoMCreate";
import { BoMEdit } from "./BoMEdit";
import { BoMList } from "./BoMList";
import { BoMShow } from "./BoMShow";

export const boms = {
    list: BoMList,
    show: BoMShow,
    create: BoMCreate,
    edit: BoMEdit,
    recordRepresentation: 'reference'
};
